import React from "react";

const FeatureRequestCard = ({
  record,
  isLibrary,
  onOpen,
  onMarkDone,
  onReopen,
  onRequestDelete,
  isMarkingDone,
  isReopening,
  isDeleting,
}) => {
  const userName = record.user
    ? `${record.user.first_name || ""} ${record.user.last_name || ""}`.trim()
    : "Unknown user";
  const companyName =
    record.company?.company_name || record.company?.business_name || "No company";

  return (
    <article
      className={`fr-card fr-card--${(record.priority || "p7").toLowerCase()} ${
        isLibrary ? "fr-card--done" : ""
      }`}
      onClick={() => onOpen(record)}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpen(record);
        }
      }}
    >
      <div className="fr-card__top">
        <div className="fr-card__title-wrap">
          <h3 className="fr-card__title">{record.title}</h3>
          <div className="fr-card__meta-row">
            <span className="fr-badge fr-badge--priority">{record.priority}</span>
            <span className="fr-badge fr-badge--category">
              {record.category_label}
            </span>
            {isLibrary ? (
              <span className="fr-badge fr-badge--done">Done</span>
            ) : null}
            <span
              className={`fr-badge ${
                record.is_paid ? "fr-badge--paid" : "fr-badge--unpaid"
              }`}
            >
              {record.paid_label}
            </span>
            <span className="fr-badge fr-badge--plan">{record.plan_name}</span>
            <span
              className={`fr-badge ${
                record.is_active ? "fr-badge--active" : "fr-badge--inactive"
              }`}
            >
              {record.is_active ? "Active" : "Inactive"}
            </span>
          </div>
        </div>
        <div className="fr-card__date">
          {isLibrary && record.marked_done_at
            ? `Done ${record.marked_done_at}`
            : record.created_at}
        </div>
      </div>

      <p className="fr-card__description">{record.description}</p>

      <div className="fr-card__footer">
        <div className="fr-card__user">
          <strong>{userName}</strong>
          <span>{record.user?.email || "-"}</span>
        </div>
        <div className="fr-card__footer-actions">
          {!isLibrary ? (
            <button
              type="button"
              className="fr-card__done-btn"
              disabled={isMarkingDone || isDeleting}
              onClick={(event) => {
                event.stopPropagation();
                onMarkDone(record);
              }}
            >
              {isMarkingDone ? "Saving..." : "Mark as done"}
            </button>
          ) : (
            <button
              type="button"
              className="fr-card__reopen-btn"
              disabled={isReopening || isDeleting}
              onClick={(event) => {
                event.stopPropagation();
                onReopen(record);
              }}
            >
              {isReopening ? "Saving..." : "Move back to inbox"}
            </button>
          )}
          <button
            type="button"
            className="fr-card__delete-btn"
            disabled={isMarkingDone || isReopening || isDeleting}
            onClick={(event) => {
              event.stopPropagation();
              onRequestDelete(record);
            }}
          >
            Delete
          </button>
          <div className="fr-card__company">
            <strong>{companyName}</strong>
            <span>{record.company?.slug || record.company?.company_email || ""}</span>
          </div>
        </div>
      </div>
    </article>
  );
};

export default FeatureRequestCard;
